import VehiclesView from "./view";
import { useDispatch, useSelector } from "react-redux";
import { ReducersTypes } from "@/redux/reducers/Models";
import { useEffect, useState } from "react";
import { authorize, setUser } from "@/redux/ducks/user";
import { useLocation, useNavigate } from "react-router-dom";
import { PropsView } from "./Models";
// Temporariamente removido - captchas desabilitados
// import useCaptchaEnterprise from "@/hooks/useCaptchaEnterprise";
// import { useSingleFlag } from "@/hooks/useFlags";

export default function Vehicles() {
  const navigate = useNavigate();
  const TIMEOUT = 500;

  const dispatch = useDispatch();
  const user = useSelector((state: ReducersTypes) => state.userReducer);
  // Temporariamente removido - captchas desabilitados
  // const { isEnabled: isCaptchaMtcCaptcha } = useSingleFlag('PD_CAPTCHA_MTCAPTCHA');

  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [plate, setPlate] = useState<string>(user?.plate as string ?? "");
  // Temporariamente sempre true - captchas desabilitados
  const [isVerified] = useState(true);

  // Temporariamente removido - captchas desabilitados
  // const captchaName = "vehicles-captcha";
  // useCaptchaEnterprise({ 
  //   captchaName, 
  //   setIsVerified,
  //   action: 'vehicle_change'
  // });

  // Temporariamente removido - captchas desabilitados
  // useEffect(() => {
  //   const token = (window as any)?.getRecaptchaToken?.();
  //   if (token) {
  //     setIsVerified(true);
  //   }
  // }, [location.pathname]);

  const toggleModal = () => setIsVisibleModal(isVisibleModal => !isVisibleModal);

  const goBack = () => navigate(-1);

  const getIsDisabled = () => {
    return isLoading || plate?.length < 8 || plate?.toLowerCase() === String(user?.plate ?? "")?.toLowerCase() || !isVerified;
  }

  const handleKeyDown: PropsView['handleKeyDown'] = (event) => {
    if (event.key === 'Enter') {
      change();
    }
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    setPlate(value);
  }

  const handleAuthorize = (success: boolean, errorMessage?: string) => {
    setIsLoading(false);

    if (!success) {
      if (errorMessage === "timeout") setError(true);
      toggleModal();
      // Temporariamente removido - captchas desabilitados
      // Reset reCAPTCHA
      // if (typeof window !== "undefined" && (window as any).grecaptcha?.reset) {
      //   (window as any).grecaptcha.reset();
      // }
      return;
    }

    dispatch(
      setUser({
        plate,
        requestId: undefined,
        debts: undefined,
        cart: undefined,
      })
    );

    setTimeout(() => {
      goBack();
    }, TIMEOUT);
  }

  const change = (e?: React.ChangeEvent<HTMLFormElement>) => {
    
    e?.preventDefault();
    
    if (getIsDisabled()) return;

    setIsLoading(true);    
    
    // Temporariamente removido - captchas desabilitados
    const authPayload: any = {
      plate,
      token: '', // Token vazio temporariamente
      callback: handleAuthorize,
    };
    
    // Temporariamente removido - captchas desabilitados
    // if (!isCaptchaMtcCaptcha && (window as any).getRecaptchaAction) {
    //   authPayload.recaptchaAction = (window as any).getRecaptchaAction();
    // }

    dispatch(authorize(authPayload));
  }

  return (
    <VehiclesView
      goBack={goBack}
      change={change}
      plate={plate}
      onChange={onChange}
      isLoading={isLoading}
      isVisibleModal={isVisibleModal}
      error={error}
      toggleModal={toggleModal}
      handleKeyDown={handleKeyDown}
      isDisabled={getIsDisabled()}
    />
  );
}